export default __webpack_public_path__ + "assets/138bc206c26716ff3905e9926096f688.png";